import DropdownMenu from "@/common/components/DropdownMenu"
import { BillResumeData, BillStatusEnum } from "../types/bills.type";
import { useState } from "react";
import BillRejectModal from "./actions/BillRejectModal";
import { CompanyData } from "@/features/company/types/company.type";

interface BillHeaderDropdownActionsProps {
  bill: BillResumeData | undefined;
  company?: CompanyData;
}

const BillHeaderDropdownActions = ({ bill, company }: BillHeaderDropdownActionsProps) => {
  const [rejectModalIsOpen, setRejectModalIsOpen] = useState(false);

  const shouldDisplayRejectButton = company?.require_bill_review === 'always' && bill?.status && [
    BillStatusEnum.InProcess,
  ].includes(bill?.status);

  if (![
    shouldDisplayRejectButton,
  ].some(Boolean)) {
    return null;
  }

  return (
    <>
      <DropdownMenu
        triggerLabel='Ações'
        dataTestId="bill_actions_dropdown_trigger"
        options={[
          ...(shouldDisplayRejectButton ? [{
            label: "Rejeitar fatura",
            onClick: () => setRejectModalIsOpen(true),
            operationKlassToCheckPermission: "Client::Billing::Bills::Reject",
            dataTestId: "reject_bill",
          }] : []),
        ]}
        menuPositionAlign="end"
      />

      <BillRejectModal
        billId={bill?.id}
        isOpen={rejectModalIsOpen}
        setIsOpen={setRejectModalIsOpen}
      />
    </>
  );
}

export default BillHeaderDropdownActions;
